import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import './viden.css';
import SecondaryButton from '../../components/secondaryButton';

// Funktion til at konvertere markdown til HTML
const markdownToHtml = (markdown) => {
  if (!markdown) return '';

  // Konverter overskrifter
  let html = markdown.replace(/^## (.*?)$/gm, '<h3>$1</h3>');
  html = html.replace(/^# (.*?)$/gm, '<h2>$1</h2>');

  // Konverter fed tekst
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Konverter links
  html = html.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

  // Konverter bullet points
  html = html.replace(/^- (.*?)$/gm, '<li>$1</li>');
  
  // Konverter almindelige linjer til paragraffer, bevar de ovenstående konverteringer
  html = html.split(/\n/).map(line => {
    if (line.startsWith('<li>') || line.startsWith('<h2>') || line.startsWith('<h3>') || line.startsWith('<a ')) {
      return line;
    }
    return line === '' ? '<br/>' : `<p>${line}</p>`;
  }).join('');

  // Wrap bullets i ul tags
  html = html.replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>');

  // Fjern ekstra <br/> tags
  html = html.replace(/<p><br\/><\/p>/g, '<br/>');
  html = html.replace(/<br\/><br\/>/g, '<br/>');

  return html;
};

const VidenArtikel = () => {
  const { artikelId } = useParams();
  const [artikel, setArtikel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const fetchArtikel = async () => {
      try {
        setLoading(true);
        const videnDoc = await getDoc(doc(db, 'content', 'viden'));
        
        if (videnDoc.exists()) {
          const data = videnDoc.data();
          
          // Find den specifikke artikel baseret på URL path
          const path = `/viden/${artikelId}`;
          const matchingArtikel = data.artikler && data.artikler.find(a => 
            a.link === path || a.id === artikelId
          );
          
          if (matchingArtikel) {
            setArtikel(matchingArtikel);
            
            // Hent også tags til at vise kategorier
            if (data.tags) {
              setTags(data.tags);
            }
          } else {
            setError('Artiklen blev ikke fundet.');
          }
        } else {
          setError('Kunne ikke hente artikel data.');
        }
      } catch (err) {
        console.error('Fejl ved indlæsning af artikel:', err);
        setError('Der opstod en fejl ved indlæsning af artiklen. Prøv venligst igen senere.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchArtikel();
  }, [artikelId]);

  if (loading) {
    return (
      <div className="viden-side">
        <div className="viden-container loading-container">
          <div className="loading-spinner"></div>
          <p>Indlæser artikel...</p>
        </div>
      </div>
    );
  }

  if (error || !artikel) {
    return (
      <div className="viden-side">
        <div className="viden-container error-container">
          <h2>Ups, noget gik galt</h2>
          <p>{error || 'Artiklen blev ikke fundet.'}</p>
          <Link to="/viden">
            <SecondaryButton>Tilbage til Viden</SecondaryButton>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="viden-side">
      <div className="viden-container viden-artikel-container">
        <div className="viden-artikel-breadcrumb">
          <Link to="/viden">Viden</Link> / {artikel.title}
        </div>
        
        <div className="viden-artikel">
          <div className="viden-artikel-header">
            <h1>{artikel.title}</h1>
            
            <div className="viden-artikel-tags">
              {artikel.tags && artikel.tags.map(tagId => (
                <span key={tagId} className="viden-artikel-tag">
                  {tags.find(t => t.id === tagId)?.name}
                </span>
              ))}
            </div>
            
            {artikel.image && (
              <div className="viden-artikel-hero">
                <img src={artikel.image} alt={artikel.title} />
              </div>
            )}
          </div>
          
          <div className="viden-artikel-description">
            <p>{artikel.description}</p>
          </div>
          
          <div className="viden-artikel-content" dangerouslySetInnerHTML={{ __html: markdownToHtml(artikel.content) }}>
          </div>
          
          <div className="viden-artikel-footer">
            <Link to="/viden">
              <SecondaryButton>Tilbage til Viden</SecondaryButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VidenArtikel; 